export default {
    message: {
      ConnectWallet: '连接钱包',
      Defi: '免质押挖矿',
      Reward: '奖励',
      ReceiveVoucher: '授权凭证',
      MiningPool: '矿池',
      Account: '账户',
      PoolData: "矿池数据",
      TotalOutput: "总产量",
      ValidNode: "有效节点",
      Participant: "参与者",
      UserRevenue: "用户收入",
      Mining: "采矿",
      LiquidityMiningIncome: "流动性采矿收入",
      UserOutput: "用户输出",
      Address: "地址",
      Quantity: "数量",
      HelpCenter: "帮助中心",
      HelpCenter2: "希望对你有帮助",
      Question1: "什么是节点挖掘？",
      Question2: "采矿收入来自哪里？",
      Question3: "我需要如何加入？",
      Question4: "我怎样提现？",
      Question5: "收益率是多少？",
      Question6: "额外的收益是什么？",
      Question7: "如何联系你？",
      Answer1: "USDT存储在自己的钱包中，0风险，新的区块链数据管理和计算模型，以促进DEFI生态。通过每个用户节点的总价值生产、无保留的流动性节点挖掘以及预挖掘和增量行为，所有ETH用户提供链上流动性，所有这些都将通过智能合约节点执行收入自动锁定。目前，您可以通过任何钱包参与，对矿工新一代节点进行挖掘，在通过流动性节点挖掘获得的总收入结束时，通过USDT代币分割每个用户的集中钱包。",
      Answer2: "一旦用户参与挖掘，流动性节点挖掘将被激活，每天节点挖掘产生的总金额将在24小时内结束，每个用户从Minres新一代流动性节点池中获取挖掘数据，用于计算收益。每日结算6次，每4小时结算1次，挖矿收益以液体节点池用户钱包代币百分比计算。成功提交社区后，挖掘收益将被释放到用户的中央钱包。移动节点挖掘的总量占用户钱包token总量的比例。你在移动池中拥有的代币越多，你从挖掘中获得的代币就越多。",
      Answer3: " 参与非破坏性和非担保流动性挖掘需要支付ETH或者TRX矿工费用才能收到替换金券，ETH钱包或者TRX钱包地址只需申请一次。成功后自动打开挖掘权限 ",
      Answer4: " 您可以将每天生成的货币转换为USDT，然后启动提款。USDT取款将自动发送到您添加到节点的钱包地址，不支持其他地址 ",
      Answer5: "100USDT以下沒有盈利。",
      Answer6: "当你每天有足够的挖掘量，并持续保持足够的时间，挖掘池将有很多奖励。有关更多详细信息，请联系在线客户服务。 ",
      Answer7: "请发送电子邮件，我们将在收到电子邮件后立即回复您；",
      Yield: "收益率",
      AuditReport: "审计报告",
      AuditReport2: "我没有一份安全的审计报告",
      Partner: "伙伴",
      Partner2: "我们的商业伙伴",
      MyAccount: "我的账户",
      ReceiveDescription: "授权描述",
      Description: "您需要支付矿费才能收到凭证，请确保您的钱包有足够的ETH作为矿费",
      Receive: "授权",
      TotalOutput: "总产量",
      IncomeBalance: "收入余额",
      Exchangeable: "可兑换",
      Exchange: "兑换",
      RedeemAll: "全部兑换",
      Price: "价格", 
      Withdraw: "提现",
      WithdrawalAmount: "提现金额",
      TotalBalance: "总金额",
      Confirm: "确认",
      Tip1: "从0.1分开始，将您挖掘的ETH硬币转换为USDT",
      Tip2: "USDT取款将在24小时内发送到您的USDT钱包地址，每天只能取款一次，从{min}USDT开始，每位矿工的费用为{fee}USDT",
      Record: "记录",
      Time: "时间",
      Status: "状态",
      Type: "类型",
      Output: "输出",
      Succeed: "成功",
      Fail: "失败",
      Withdrawing: "提现中",
      Withdrawing2: "提现申请已提交",
      NOETH: "没有可兑换的ETH",
      NOETH2: "可兑换的ETH不足",
      ExchangeSuc: '兑换成功',
      MinWithdrawCount: '最小提现金额为',
      Submitting: '提交中...',
      ApproveTip: '请先授权凭证'
    }
}